export const AuthSource = {
  FrontOffice: 'FRONTOFFICE' as const,
  BackOffice: 'BACKOFFICE' as const,
  Admin: 'CONFIGURATORE' as const,
};

export type AuthSource = (typeof AuthSource)[keyof typeof AuthSource];

export function authSourceToPath(source: AuthSource) {
  switch (source) {
    case AuthSource.FrontOffice:
      return '/frontoffice' as const;
    case AuthSource.BackOffice:
      return '/backoffice' as const;
    case AuthSource.Admin:
      return '/admin' as const;
  }
}
